import { EmptyState } from '../../ds/components';
import { usePermissions } from '../../lib/session';
import { LockedPage } from '../../shell/ModulePages';
import styles from './PkvPage.module.css';

export const PKV_EMPTY_TEXT =
  'PKV-Deals, Risikovoranfragen und der Rechner erscheinen hier mit dem nächsten Ausbau.';

/**
 * Tool „PKV" (PKV M0, D-288): the gate of `tools.pkv` (module `pkv` active and the right) and the empty state of
 * the tool until the PKV deals, risk inquiries and the calculator arrive (PLAN-PKV M1 ff.).
 */
export function PkvPage() {
  const permissions = usePermissions();
  if (permissions.tool('pkv') !== 'ok') return <LockedPage tool="pkv" />;
  return (
    <div className={styles.stage}>
      <EmptyState eyebrow="PKV" title={PKV_EMPTY_TEXT} />
    </div>
  );
}
